import React from 'react';
import HtmlParseComponent from '../htmlParsingComponent';

interface FormatTextProps {
  text: any;
  dataType: any;
}
export const FormatText: React.FC<FormatTextProps> = ({ text, dataType }) => {
  const renderText = (dataType: string) => {
    switch (dataType) {
      case 'text':
        return text;
      case 'richText':
        return <HtmlParseComponent richText={text} />;
      default:
        return text;
    }
  };

  return <> {renderText(dataType)} </>;
};
